module.exports = __webpack_public_path__ + "static/heckmondwike-grammar-school-bus-2e75eeca05bca20a2c85e21a7ac1b9a6.jpg";